var _filter, _circle, _ellipse, _circle2, _circle3, _circle4, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stormClouds11d",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#64748B",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#334155",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "stormShadow11d"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 5,
    stdDeviation: 4,
    floodColor: "#1E293B",
    floodOpacity: 0.6
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 4,
    fill: "#FFE066",
    opacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 32,
    rx: 25,
    ry: 16,
    fill: "url(#stormClouds11d)",
    filter: "url(#stormShadow11d)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 28,
    r: 12,
    fill: "url(#stormClouds11d)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 28,
    r: 14,
    fill: "url(#stormClouds11d)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 22,
    r: 10,
    fill: "url(#stormClouds11d)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 50 L48 62 L54 62 L46 78 L58 65 L52 65 Z",
    fill: "#FEF08A",
    stroke: "#EAB308",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1E40AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 50,
    x2: 32,
    y2: 68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 52,
    x2: 62,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 55,
    x2: 39,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 54,
    x2: 55,
    y2: 72
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11D);
export default __webpack_public_path__ + "static/media/11d.495b8946f063777dd3a5a1eb22e8faeb.svg";
export { ForwardRef as ReactComponent };